__turbopack_context__.v({
  "sectionSpacing": "info-bar-module-scss-module__triWNW__sectionSpacing",
});
